/* eslint-disable */
import * as Types from './types';

import { ImageFragmentDoc } from './Image';
export type BlogNavFragment = { __typename: 'BlogNav', heading?: string | null, blogNavItemsCollection?: { __typename?: 'BlogNavBlogNavItemsCollection', items: Array<{ __typename?: 'BlogNavItem', title?: string | null, path?: string | null, openLinkInNewTab?: boolean | null, image?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null } | null> } | null };

export declare const BlogNavFragment: import("graphql").DocumentNode;
export const BlogNavFragmentDoc = /*#__PURE__*/ `
    fragment BlogNavFragment on BlogNav {
  __typename
  heading
  blogNavItemsCollection(limit: 10) {
    items {
      image {
        ...ImageFragment
      }
      title
      path
      openLinkInNewTab
    }
  }
}
    `;